module.exports = __webpack_public_path__ + "img/sending_4.3372cce6.png";